<nz-modal [nzVisible]="!!aiDialogId"
          [nzTitle]="modalTitle"
          nzCentered
          [nzMask]="hasModalMask"
          nzClassName="ai-input-modal"
          nzWrapClassName="ai-input-wrap"
          [nzCancelText]="'Close'"
          [nzOkText]="'Ok'"
          [nzOkDisabled]="showSaveConfirmation"
          (nzOnCancel)="aiDialogId = ''"
          (nzOnOk)="handleOkClicked()">
  <ng-container *nzModalContent>


    <nz-spin nzTip="Rapider AI is in progress, please wait..."
             [nzSpinning]="aiInProgress"
             [nzSize]="'large'">
      <!-- *ngIf="!showSaveConfirmation" -->
      <div class="ai-input-container">
        <textarea id="aiInputTextArea"
                  class="ai-input-textarea"
                  [(ngModel)]="aiInputText"
                  rows="8"
                  placeholder="placeholder"></textarea>
        <label for="aiInputTextArea"
               class="ai-input-label">explanation</label>
      </div>


      <!-- Confirmation -->
      <div *ngIf="showSaveConfirmation"
           class="ai-input-save-confirmation">
        <p class="w-100">{{confirmationText}}</p>
        <div class="w-100 confirmation-button-container">
          <button nz-button
                  nzType="primary"
                  (click)="onConfirmClicked()">{{confirmButtonTitle}}</button>
          <button nz-button
                  (click)="onDiscardConfirmClicked()">No, discard changes</button>
        </div>

      </div>
      <!-- End of Confirmation -->
    </nz-spin>


  </ng-container>

</nz-modal>
